// accounts
export const SWEEP_TRANSACTION_CODES = [191, 192]

// SPLIT CHAR
export const BRAZE_SPLIT_CHAR = '__'

// transactions
export const TRANSACTIONS_LIMIT = '30'

export const TRANSACTIONS_INFINITE_PARAMS = {
  transactionsInput: {
    limit: TRANSACTIONS_LIMIT,
    next: null,
    prev: null,
  },
}

export const ROUTING_NUMBER_MASK = '999999999'
export const ACCOUNT_NUMBER_MASK = '99999999999999999'
export const ACCOUNT_NUMBER_MIN_LENGTH = 5
export const ACCOUNT_NUMBER_MAX_LENGTH = 17
export const WIRE_BENEFICIARY_NAME_MAX_LENGTH = 35

export const CUSTOMER_SERVICE_PHONE_NUMBER = '+18888840557'
export const CUSTOMER_SERVICE_PHONE_NUMBER_DISPLAY = '+1 (888) 884-0557'
export const CUSTOMER_SERVICE_EMAIL = 'clientservice@evergreenwealth.com'

export const STATES_OPTIONS = [
  {
    label: 'Alaska',
    value: 'AK',
  },
  {
    label: 'Alabama',
    value: 'AL',
  },
  {
    label: 'Arkansas',
    value: 'AR',
  },
  {
    label: 'American Samoa',
    value: 'AS',
  },
  {
    label: 'Arizona',
    value: 'AZ',
  },
  {
    label: 'California',
    value: 'CA',
  },
  {
    label: 'Colorado',
    value: 'CO',
  },
  {
    label: 'Connecticut',
    value: 'CT',
  },
  {
    label: 'District of Columbia',
    value: 'DC',
  },
  {
    label: 'Delaware',
    value: 'DE',
  },
  {
    label: 'Florida',
    value: 'FL',
  },
  {
    label: 'Federated States of Micronesia',
    value: 'FM',
  },
  {
    label: 'Georgia',
    value: 'GA',
  },
  {
    label: 'Guam',
    value: 'GU',
  },
  {
    label: 'Hawaii',
    value: 'HI',
  },
  {
    label: 'Iowa',
    value: 'IA',
  },
  {
    label: 'Idaho',
    value: 'ID',
  },
  {
    label: 'Illinois',
    value: 'IL',
  },
  {
    label: 'Indiana',
    value: 'IN',
  },
  {
    label: 'Kansas',
    value: 'KS',
  },
  {
    label: 'Kentucky',
    value: 'KY',
  },
  {
    label: 'Louisiana',
    value: 'LA',
  },
  {
    label: 'Massachusetts',
    value: 'MA',
  },
  {
    label: 'Maryland',
    value: 'MD',
  },
  {
    label: 'Maine',
    value: 'ME',
  },
  {
    label: 'Marshall Islands',
    value: 'MH',
  },
  {
    label: 'Michigan',
    value: 'MI',
  },
  {
    label: 'Minnesota',
    value: 'MN',
  },
  {
    label: 'Missouri',
    value: 'MO',
  },
  {
    label: 'Northern Mariana Islands',
    value: 'MP',
  },
  {
    label: 'Mississippi',
    value: 'MS',
  },
  {
    label: 'Montana',
    value: 'MT',
  },
  {
    label: 'North Carolina',
    value: 'NC',
  },
  {
    label: 'North Dakota',
    value: 'ND',
  },
  {
    label: 'Nebraska',
    value: 'NE',
  },
  {
    label: 'New Hampshire',
    value: 'NH',
  },
  {
    label: 'New Jersey',
    value: 'NJ',
  },
  {
    label: 'New Mexico',
    value: 'NM',
  },
  {
    label: 'Nevada',
    value: 'NV',
  },
  {
    label: 'New York',
    value: 'NY',
  },
  {
    label: 'Ohio',
    value: 'OH',
  },
  {
    label: 'Oklahoma',
    value: 'OK',
  },
  {
    label: 'Oregon',
    value: 'OR',
  },
  {
    label: 'Pennsylvania',
    value: 'PA',
  },
  {
    label: 'Puerto Rico',
    value: 'PR',
  },
  {
    label: 'Palau',
    value: 'PW',
  },
  {
    label: 'Rhode Island',
    value: 'RI',
  },
  {
    label: 'South Carolina',
    value: 'SC',
  },
  {
    label: 'South Dakota',
    value: 'SD',
  },
  {
    label: 'Tennessee',
    value: 'TN',
  },
  {
    label: 'Texas',
    value: 'TX',
  },
  {
    label: 'Utah',
    value: 'UT',
  },
  {
    label: 'Virginia',
    value: 'VA',
  },
  {
    label: 'Virgin Islands',
    value: 'VI',
  },
  {
    label: 'Vermont',
    value: 'VT',
  },
  {
    label: 'Washington',
    value: 'WA',
  },
  {
    label: 'Wisconsin',
    value: 'WI',
  },
  {
    label: 'West Virginia',
    value: 'WV',
  },
  {
    label: 'Wyoming',
    value: 'WY',
  },
]
